import { onServerWaking } from "@app/storage";
import { toast, useToastStore } from "../stores/toast.store.js";
import { tr } from "./tr.js";

/**
 * Show a single sticky "server is waking up" toast whenever a request to the
 * hosted backend is slow/retrying (Render free tier cold-starts after idle), and
 * dismiss it once everything settles. Covers every server call — sign-in, the
 * Google token proxy, and sync — since they all share the transport. Call once
 * at boot (from `main.tsx`); returns an unsubscribe.
 */
export function registerServerWakingToast(): () => void {
  let toastId: number | null = null;
  return onServerWaking((waking) => {
    if (waking && toastId == null) {
      toastId = toast.info(
        tr("toast.server.waking"),
        0, // sticky until we dismiss it
      );
    } else if (!waking && toastId != null) {
      useToastStore.getState().dismiss(toastId);
      toastId = null;
    }
  });
}
